import { Waves, Play, X } from "lucide-react";
import { useLang } from "@/i18n";

// Shown after beating Corn Island: offers the Underwater Treasure Dive bonus
// with a Play / Skip choice before the dive starts.
export default function OceanBonusPrompt({ onPlay, onSkip }) {
  const { t } = useLang();
  return (
    <div className="absolute inset-0 z-[70] overflow-y-auto"
      style={{ background: "radial-gradient(ellipse at 50% 35%, #0c4a66 0%, #06121f 78%)" }}
      data-testid="ocean-prompt">
      <div className="min-h-full flex flex-col items-center justify-center p-4 py-8">
        <div className="relative flex flex-col items-center text-center pixel-card bg-[#0b2b44]/95 max-w-sm w-full p-5 nb-pop">
          <span className="text-3xl mb-1">🌊</span>
          <h2 className="font-pixel text-base md:text-lg text-[#7fe9ff] pixel-stroke leading-tight" data-testid="ocean-prompt-title">
            {t("oceanPromptTitle")}
          </h2>
          <p className="font-vt text-white/85 text-sm md:text-base mt-1.5 leading-snug">{t("oceanPromptBody")}</p>

          <div className="flex flex-col gap-2 w-full mt-4">
            <button data-testid="ocean-prompt-play-btn" onClick={onPlay}
              className="pixel-btn bg-[#0fb6d6] text-white w-full py-3 text-sm blink flex items-center justify-center gap-2">
              <Play size={16} strokeWidth={2.5} fill="#fff" /> {t("bonusPlay")}
            </button>
            <button data-testid="ocean-prompt-skip-btn" onClick={onSkip}
              className="pixel-btn bg-[#222] text-white w-full py-2.5 text-xs flex items-center justify-center gap-2">
              <X size={15} strokeWidth={2.5} /> {t("bonusSkip")}
            </button>
          </div>
          <Waves size={14} className="text-white/30 mt-3" />
        </div>
      </div>
    </div>
  );
}
